import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import {
  AccountEntryService,
  LoginState,
} from 'src/app/account/account-entry/account-entry.service';
import { LangCodeMap, LangCode, DEFAULT_LANG_CODE } from 'src/app/models/localization.model';
import { AuthService } from 'src/app/services/auth.service';
import { UserService } from 'src/app/services/user.service';
import { Location } from '@angular/common';
import { TelemetryService } from 'src/app/services/telemetry.service';
import { sortByString } from '../utils/common-util';
import {
  removeQueryParamsFromUrl,
  ActionsQueryParamKeys,
  getLanguageQueryParam,
} from '../utils/actions-query-params-util';

@Component({
  selector: 'app-login-header',
  templateUrl: './login-header.component.html',
  styleUrls: ['./login-header.component.scss'],
})
export class LoginHeaderComponent implements OnInit {
  @Input() showLogo = true;
  @Input() redirectWithoutParams = false;
  @Input() showLogout = false;
  @Input() addBotBorder = false;
  @Input() institutionLogo?: string;
  @Input() logoIsLoading = false;

  protected displayLangName: string;
  public langCodeList: LangCode[] = LangCodeMap.filter((code) => code.originalLabel).sort(
    (a: any, b: any) => sortByString(a, b, 'label'),
  );
  public currentSelectedLanguage = <LangCode>(
    LangCodeMap.find((code) => code.code === DEFAULT_LANG_CODE)
  );

  constructor(
    private authService: AuthService,
    private router: Router,
    private userService: UserService,
    private accountEntryService: AccountEntryService,
    private location: Location,
    private telemetryService: TelemetryService,
  ) {
    this.displayLangName = this.currentSelectedLanguage?.originalLabel?.substring(4) ?? '';
  }

  ngOnInit(): void {
    this.setInitialLanguage();
  }

  setInitialLanguage(): void {
    let selectedLangCode = getLanguageQueryParam(this.langCodeList);
    if (!selectedLangCode) {
      selectedLangCode = DEFAULT_LANG_CODE;
    }
    this.currentSelectedLanguage = <LangCode>(
      LangCodeMap.find((code) => code.code === selectedLangCode)
    );
    this.changeLang(this.currentSelectedLanguage, false);
  }

  signOut() {
    this.authService.showLogoutConfirmationDialog();
  }

  goToLogin() {
    this.accountEntryService.loginInfoChanges.next({ loginState: LoginState.START });
    this.router.navigate(['account', 'login'], {
      queryParamsHandling: this.redirectWithoutParams ? '' : 'preserve',
    });
  }

  changeLang(langCode: LangCode, removeLanguageQueryParam: boolean) {
    if (removeLanguageQueryParam) {
      removeQueryParamsFromUrl(this.location, this.telemetryService, [
        ActionsQueryParamKeys.LANGUAGE,
      ]);
    }
    this.userService.setLanguage(langCode);
    this.currentSelectedLanguage = langCode;
    this.displayLangName = this.currentSelectedLanguage.originalLabel?.substring(4) ?? '';
  }
}
